import React, { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component';
import OrgPostCard from '../components/OrgPostCard';
import Loader from '../components/Loader';
import { api } from '../app/Api/ApiSlice';

const UserEvents = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [currentPosts, setCurrentPosts] = useState([])
    const [hasMore, setHasMore] = useState()

    useEffect(() => {

        const getOrgFeeds = async () => {
            try {
                setIsLoading(true)
                const response = await api.get("/feeds/events", { page })
                if (response) {
                    setIsLoading(false)
                    // console.log(response)
                    setCurrentPosts((prev) => [...prev, ...response.data])
                    setHasMore(response.data.length === 20)
                }
            } catch (error) {
                setIsLoading(false)
                console.log(error)
                // toast.error(error.response.data.message)
            }
        }

        getOrgFeeds()
    }, [page])

    const handleRefresh = async () => { }
    return (
        <div>
            <div className="org-feed-content">
                {currentPosts && currentPosts.length > 0 ? (
                    <InfiniteScroll
                        dataLength={currentPosts.length}
                        next={() => setPage((prev) => prev + 1)}
                        hasMore={hasMore}
                        refreshFunction={handleRefresh}
                    >
                        {currentPosts.map((post) => {
                            return (
                                <div key={post._id} className="home-feed-post" >
                                    <div className="org-event-details">
                                        <img src={post.organization.logo} alt="" />
                                        <h4>{post.organization.name}</h4>
                                    </div>
                                    <OrgPostCard post={post} />
                                </div>
                            );
                        })}
                    </InfiniteScroll>
                ) : (
                    !isLoading && <p className="not-found-msg">{`No Events available`}</p>
                )}
                {isLoading && <Loader />}
            </div>
        </div>
    )
}

export default UserEvents